/**
 * Match category keywords as whole words/phrases, not substrings.
 * e.g. "mall" must not match "small".
 */
export function textContainsKeyword(text, keyword) {
  if (!text || !keyword) return false;
  const normalized = String(text).toLowerCase();
  const kw = String(keyword).toLowerCase().trim();
  if (!kw) return false;
  const escaped = kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`\\b${escaped}\\b`, 'i').test(normalized);
}

export function getCategoryFromKeywordRules(entityName, rules) {
  if (!entityName) return null;
  for (const rule of rules) {
    if (rule.keywords.some((kw) => textContainsKeyword(entityName, kw))) {
      return rule.category;
    }
  }
  return null;
}
